export enum AppRideStatus {
    Riding = '[AppRideStatus] Riding',
    Paused = '[AppRideStatus] Paused',
    EndRideDetails = '[AppRideStatus] EndRideDetails',
    Finalized = '[AppRideStatus] finalized'
}
